import type { RefrigerationUnitComponentRow } from '../../db';
import { RefrigerationUnitComponent } from '../../schemas';
import { newId } from '../../../utils/ids';
import { trim, toNonNegativeInt, toNonNegativeNumber } from '../repoUtils';
import type { RefrigerationUnitComponentInput } from './types';

export function normalizeRefrigerationUnitComponents(
  input: Array<RefrigerationUnitComponentInput | RefrigerationUnitComponentRow> | undefined,
  existing: RefrigerationUnitComponentRow[] | undefined
): RefrigerationUnitComponentRow[] {
  const source = input ?? existing ?? [];
  return source.map((component) => {
    const baseType = (component as RefrigerationUnitComponentInput).type ?? component.type;
    const type = trim(baseType ?? undefined);
    const customLabel = trim(
      (component as RefrigerationUnitComponentInput).customLabel ?? component.customLabel
    );
    const hasCategory = Boolean(type);
    if (!hasCategory && !customLabel) {
      throw new Error('Specificare una categoria o una descrizione per il componente');
    }
    const quantitySource =
      (component as RefrigerationUnitComponentInput).quantity ?? component.quantity;
    const quantity =
      quantitySource === undefined || quantitySource === null
        ? undefined
        : toNonNegativeInt(quantitySource, 0);
    const capacityKw = toNonNegativeNumber(
      (component as RefrigerationUnitComponentInput).capacityKw ?? component.capacityKw
    );
    const normalized = RefrigerationUnitComponent.parse({
      id: component.id ?? newId(),
      type,
      customLabel,
      quantity,
      capacityKw,
      location: trim((component as RefrigerationUnitComponentInput).location ?? component.location),
      notes: trim((component as RefrigerationUnitComponentInput).notes ?? component.notes),
    });
    return {
      id: normalized.id,
      type: normalized.type,
      customLabel: normalized.customLabel,
      quantity: normalized.quantity,
      capacityKw: normalized.capacityKw,
      location: normalized.location,
      notes: normalized.notes,
    } satisfies RefrigerationUnitComponentRow;
  });
}
